import { tokenReplacement } from "@pheaa/channels-component-library";
import {
	TOKEN_AUTH_CLIENT_ID,
	TOKEN_HOSTNAME_ENV
} from "./tokens";

export const DEV = "dev";
export const QA = "qa";
export const PROD = "prod";

export const getIsLocalEnv = ({ hostname } = window.location) => {
	return hostname === "localhost";
};

export const getEnvFromHostname = () => {
	let { hostname } = window.location;
	let env = PROD;

	if (
		// TODO: update with hostnames from CloudFront;
		hostname === "dov4e2jbanq6u.cloudfront.net" ||
		hostname === "account.dev.pheaa.org" ||
		hostname === "localhost"
	) {
		env = DEV;
	} else if (
		// TODO: update with hostnames from CloudFront;
		hostname === "d2u6mud4unu4w.cloudfront.net" ||
		hostname === "account.qa.pheaa.org"
	) {
		env = QA;
	}

	return env.toLowerCase();
};

export const replaceAuthClientIdTokenInUrl = url => {
	let clientId = "3opvvsd25a6qfl7jdmetbgmqhb";

	if (currentEnv === QA) {
		clientId = "2rvc5vpukkmmt7832ot2vn8gfv";
	} else if (currentEnv === DEV) {
		clientId = "3vo52jvn8opjp12av6v49iiebn";
	}

	return tokenReplacement(url, TOKEN_AUTH_CLIENT_ID, clientId);
};

export const replaceEnvTokenInUrl = url => {
	// Set replacement string to empty string;
	let envReplacement = ".";
	// If non-prod environment;
	if (currentEnv !== PROD) {
		// Set replacement string to current env;
		envReplacement = `.${currentEnv}.`;
	}

	return tokenReplacement(url, TOKEN_HOSTNAME_ENV, envReplacement);
};

export const currentEnv = getEnvFromHostname();
export const isLocalEnv = getIsLocalEnv();